import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import VRFSystemDetail from '../../components/vrf/VRFSystemDetail';
import { defaultRejectHandler } from '../../utils/utility';
import {
  getVRFSystem,
  editVRFSystem,
} from '../../redux/vrf/vrf_system_actions';

class VRFSystemEditModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
      itemsDirty: false,
    };
    this.detail = undefined;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.system !== nextProps.system && nextProps.show) {
      this.props.get(nextProps.system.id);
    }
  }

  // UAT feedback 9/10/2569: เดิมปุ่ม Save ขึ้นกับ dirty ของ Form (ชื่อ/คำอธิบาย) อย่างเดียว
  // → แก้แค่ outdoor/indoor แล้วกด Save ไม่ได้ ปิด modal ข้อมูลที่เลือกไว้หายเพราะไม่เคยถูกบันทึก
  canSave() {
    const { isDirty, isSubmittable, itemsDirty } = this.state;
    return isDirty ? isSubmittable : itemsDirty;
  }

  onSaveHandler() {
    const detail = this.detail.getWrappedInstance().getWrappedInstance();
    if (!detail.validate()) return;
    const data = detail.getData();
    this.props.edit(this.props.system.id, data);
  }

  render() {
    const {
      isEditing,
      errorMessage,
      detailObj,
      edit,
      get,
      system,
      t,
      ...newProps
    } = this.props;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
        onEnter={() =>
          this.setState({
            isDirty: false,
            isSubmittable: false,
            itemsDirty: false,
          })
        }
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('edit vrf system')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <VRFSystemDetail
            system={detailObj}
            ref={ref => (this.detail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            onItemsDirty={itemsDirty => this.setState({ itemsDirty })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isEditing && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="vrf-system-submit-edit"
            disabled={!this.canSave() || isEditing}
            onClick={() => this.onSaveHandler()}
          >
            {isEditing ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, props) => ({
  errorMessage: state.vrfSystem.errorMessage,
  isEditing: state.vrfSystem.isEditing,
  detailObj: props.system && state.vrfSystem.objects[props.system.id],
});

const mapDispatchToProps = dispatch => ({
  edit: (id, data) => defaultRejectHandler(dispatch(editVRFSystem(id, data))),
  get: id => defaultRejectHandler(dispatch(getVRFSystem(id))),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(VRFSystemEditModal),
);



// WEBPACK FOOTER //
// ./src/modal/vrf/VRFSystemEditModal.js